// Singleton-обёртка над wouter useLocation для axios-interceptor (который вне React-контекста).
// App.tsx при mount'е вызывает router.setPush(useLocation()[1]).
// Source of truth: docs/specs/sprint-3/stage-1-contracts.md §6.4.

let pushFn: ((path: string) => void) | null = null;

export const router = {
  setPush: (fn: (path: string) => void): void => {
    pushFn = fn;
  },
  push: (path: string): void => {
    if (pushFn) {
      pushFn(path);
    } else {
      window.location.href = path;
    }
  },
};
